import {
  LinearProgress,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

const NoResultsRow = ({
  colSpan,
  isLoading,
  noResultsMessage,
  toolTips,
}: {
  colSpan: number;
  isLoading: boolean;
  noResultsMessage: string;
  toolTips: string[];
}) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ border: "none !important" }}>
        {isLoading ? (
          <LinearProgress color="primary" />
        ) : (
          <Stack
            component="ul"
            sx={{
              padding: 2,
            }}
          >
            <Typography variant="subtitle2">
              {`No results found${noResultsMessage}.`}
            </Typography>
            <Typography
              variant="overline"
              sx={{
                paddingTop: 2,
              }}
            >
              TRY
            </Typography>
            {toolTips.map((tip, index) => (
              <Typography component="li" key={index} variant="body2">
                {tip}
              </Typography>
            ))}
          </Stack>
        )}
      </TableCell>
    </TableRow>
  );
};

export default NoResultsRow;
